const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralMotors(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 496,
    height: 496,
    viewBox: "0 0 131.233 131.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M64 0C28.654 0 0 28.654 0 64v368c0 35.346 28.654 64 64 64h368c35.346 0 64-28.654 64-64V64c0-35.346-28.654-64-64-64Zm0 32h368c17.673 0 32 14.327 32 32v368c0 17.673-14.327 32-32 32H64c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32",
    style: {
      fill: "#0671d8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2
    },
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 336v32h176v-32zm0-208v172h36V160h36v140h36V160h24c6.627 0 12 5.373 12 12v128h36V168c0-22.091-17.909-40-40-40zm-92 0c-22.091 0-40 17.909-40 40v92c0 22.091 17.909 40 40 40h32v8c0 15.464-14.327 28-32 28h-20v32h20c37.555 0 68-26.863 68-60V128Zm8 32h24v108h-24c-6.627 0-12-5.373-12-12v-84c0-6.627 5.373-12 12-12",
    style: {
      fill: "#0671d8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2
    },
    transform: "scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralMotors);
export default __webpack_public_path__ + "static/media/GeneralMotors.451e4116bf27e3215c962fe171ac621f.svg";
export { ForwardRef as ReactComponent };